class EventTarget {
  constructor(id) {
    this.targetId = id;
    this.eventListeners = {};
  }

  addEventListener(eventName, callBack) {
    this.eventListeners[eventName] = this.eventListeners[eventName] || [];
    this.eventListeners[eventName].push(callBack);
  }

  removeEventListener(eventName, callBack) {
    if (callBack) {
      let index = this.eventListeners[eventName].findIndex(callBack);
      index > -1 && this.eventListeners[eventName].splice(index, 1);
      return;
    }
    Reflect.deleteProperty(this.eventListeners, eventName);
  }

  triggerEvent(eventName, data) {
    if (Array.isArray(this.eventListeners[eventName])) {
      this.eventListeners[eventName].forEach((callBack) => callBack(data));
      return true;
    }
    return false;
  }
}

class Component extends EventTarget {
  constructor(id) {
    super(id);
    this.id = id;
  }
}

export function getComponentInstance(id, options = {}) {
  if (!window.componentInstances) {
    window.componentInstances = new Map();
  }
  if (!window.componentInstances.has(id) && options.createOnFallback) {
    let instance = new Component(id);
    window.componentInstances.set(id, instance);
  }
  return window.componentInstances.get(id);
}

export function executeComponentEvent(
  { id, eventName, executeOnce },
  data = {}
) {
  let eventListenerInstance = getComponentInstance(id);
  if (eventListenerInstance) {
    eventListenerInstance.triggerEvent(eventName, data);
    executeOnce && eventListenerInstance.removeEventListener(eventName);
  }
}
